<template>
  <div style="margin-bottom:7rem; margin-top:5rem">
    <InnerHeader/>
    <div class="row justify-content-center mt-5" >
      <div class="col-12 col-lg-11 col-md-11 col-xl-11">
        <div class="row confirmpayBG" >
           <div class="col-md-5 confirm_payment-left p-4 rounded">
            <ProductDetailsHeader/>
            <div class="row mt-3 d-flex justify-content-center">
              <ConsentDaata :selected_plan_data="selectedPlan" :checkedConditions="checkedConditions" @consent-status="condition = $event"  />
            </div>
            <div  class="d-none">
              <div class="headingcards mt-3" v-for="item in items" :key="item.heading">
              <h3>{{ item.heading }}</h3>
              <img class="confirmimage" :src="this.quoteResponseDetails && this.quoteResponseDetails.quote_response_data.supportingData.insCompanyLogo" alt="Bank Logo"  />
              <div class="d-flex align-items-center mt-3 justify-content-between">
                <p>{{ item.planType }}</p>
                <h4>{{ this.quoteResponseDetails && this.quoteResponseDetails.quote_response_data.insuranceAndProducts.policyType}}</h4>
              </div>
              <div class="d-flex align-items-center justify-content-between" v-if="this.quoteResponseDetails?.quote_response_data.insuranceAndProducts.policyType!=='StandaloneTP(1)'">
                <p>{{ item.coverType }}</p>
                <h4>{{ this.quoteResponseDetails && currency(this.quoteResponseDetails.quote_response_data.supportingData.insuredDeclaredValue.suggestedIDV) }}</h4>
              </div>
              <hr />
              <div class="d-flex align-items-center gap-1 specifications" v-for=" usp in this.extractUSP(this.quoteResponseDetails?.quote_response_data?.supportingData)"
              :key="usp">
              <img src="../../assets/images/checksvg.svg" width="10px" />
                 
                <p>{{ usp}}</p>
              </div>
              
              <hr />
              <div class="d-flex align-items-center mt-3 justify-content-between">
                <p>{{ item.premiumAmount }}</p>
                <h4>{{this.quoteResponseDetails &&  currency(this.quoteResponseDetails.quote_response_data.productDetails.totalPremiumDetails[0].totalPremiumValueBeforeTax) }}</h4>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <p>{{ item.GSTType }}</p>
                <h4>{{ this.quoteResponseDetails &&  currency(this.quoteResponseDetails.quote_response_data.productDetails.totalPremiumDetails[0].totalTax)}}</h4>
              </div>
              <hr />
              <div class="d-flex align-items-center justify-content-between">
                <h4>{{ item.amountTitle }}</h4>
                <h6>{{ this.quoteResponseDetails &&  currency(this.quoteResponseDetails.quote_response_data.productDetails.totalPremiumDetails[0].totalPremiumWithTax) }}</h6>
              </div>
              <div class="text-end">
                 <span @click="showBreakupmodal()" class="text-primary" style="font-size: 12px;text-decoration: underline;cursor: pointer;">Premium Breakup</span>
              </div>
            </div>
            
            <p v-for="(usp, index) in usps" :key="index">usp{{ usp }}</p>
            <div class="row mt-3">
              <div class="col-md-6 mb-2">
                <router-link to="/process-wizard">
                  <button class="backbutton">Back</button>
                </router-link>
              </div>
              <div class="col-md-6 mb-2">
                <!-- <router-link to="/complete-quote"> -->
                 
                  <button @click="submitproposal()" class="btn commonButton mb-2">Submit</button>
                <!-- </router-link> -->
              </div>
            </div>
            </div>
            <div>
              <p class="my-1 errorMessage" v-for="error in displayApiErrorsOnUI" :key="error">{{error}}</p>
            </div>
          </div>
          <div class="col-md-7 formobileview confirm_payment-right">
            <div class="formWizard  position-sticky p-3 rounded" style="top: 5rem;display: flex;flex-direction: column;justify-content: center; width:100%">
              <h3 class="processheading m-0">
                Confirm & Proceed
              </h3>

              <template v-if="this.structuredJSON">
                <article class="FilterAccordian headingcards mt-3" v-for="details in filteredStructureJson"
                  :key="details.id"
                  v-show="!(details.name === 'previousPolicyDetails' && quoteCategory === 'New')">
                  <header class="d-flex justify-content-between align-items-center"
                    :class="{ 'border-bottom pb-2': details.expanded }" @click="details.expanded = !details.expanded">
                    <h6 class="question-title mb-0">
                      {{ details.label }}
                    </h6>
                    <div class="d-flex gap-2 align-items-center">
                      <button @click="editProcess($event, details.name)" class="btn">
                        <img src="@/assets/images/edit-pencil.png" class="editButton"/>
                      </button>
                      <button class="btn p-0">
                        <img src="../../assets/images/minus.svg" class="plusminusicon" v-show="details.expanded" />
                        <img src="../../assets/images/plus.svg" class="plusminusicon" v-show="!details.expanded" />
                      </button>
                    </div>
                  </header>

                  <transition name="fade" mode="out-in">
                    <div v-if="details.expanded" :class="{'col-12': details.name!='nomineeInfo', 'row p-3': details.name=='nomineeInfo'}">
                      <template v-if="details.fieldGroups">
                        <div class="fieldgrp row" v-for="fieldFirst in Object.values(details.fieldGroups)"
                          :key="fieldFirst.id">
                          <h6 class="headinglables" v-if="displaySubHeading(fieldFirst)">{{ fieldFirst.label }}</h6>
                          <template v-if="fieldFirst.fields">
                            <div v-for="fieldSecond in Object.values(fieldFirst.fields)" :key="fieldSecond.id" class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6" v-show="fieldSecond.input !== '' && (!fullNameExists() || !isNameField(fieldSecond.label))">
                              <div :class="['content', !(fieldSecond.name === 'rtoCode' || fieldSecond.name === 'vehicleNumber') && 'mt-3']">
                                <div :class="['content', !(fieldSecond.name === 'rtoCode' || fieldSecond.name === 'vehicleNumber') ? 'd-flex flex-column mb-2' : 'd-flex flex-column mb-0']" v-if="fieldSecond.input !== '' && (!fullNameExists() || !isNameField(fieldSecond.label))" style="gap:8px">
                                  <template v-if="fieldSecond.name === 'rtoCode'">
                                    <template v-if="quoteCategory=='New'">
                                      <p class="diy_label mb-0">Registration Number</p>
                                      <h5 class="mb-0 text-uppercase">{{ Object.values(fieldFirst.fields).find(f => f.name === 'rtoCode')?.input }}</h5>
                                    </template>
                                  </template>
                                  <template v-else-if="fieldSecond.name === 'vehicleNumber'">
                                    <p class="diy_label mb-0">Registration Number</p>
                                    <h5 class="mb-0 text-uppercase">{{ Object.values(fieldFirst.fields).find(f => f.name === 'rtoCode')?.input }}{{Object.values(fieldFirst.fields).find(f => f.name === 'vehicleNumber')?.input}}</h5>
                                  </template>
                                  <template v-else>
                                  <p class="diy_label mb-0">{{ fieldSecond.label }}</p>
                                  <h5 v-if="fieldSecond.type=='date'" class="mb-0 text-uppercase" >{{ formatDateToMonthString(fieldSecond.input)}}</h5>
                                  <h5 v-else class="mb-0 text-uppercase">{{ (fieldSecond.input != '' && fieldSecond.input == '0') ? 'No' :
                                    (fieldSecond.input != '' && fieldSecond.input == '1') ? 'Yes' :
                                    capitalizeFirstLetter(fieldSecond.input,fieldSecond.label) }}</h5>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-if="fieldFirst.fieldGroups">
                            <div v-for="fieldSecond in Object.values(fieldFirst.fieldGroups)" :key="fieldSecond.id" class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6" v-show="fieldSecond!= undefined && fieldSecond.input != ''">
                              <div class="content mt-3" v-if="fieldSecond!= undefined && fieldSecond.input != ''">
                                <div class="d-flex flex-column mb-2" style="gap:8px">
                                  <p class="diy_label mb-0">{{ fieldSecond.label }}</p>
                                  <h5 v-if="fieldSecond.type=='date'" class="mb-0 text-uppercase" >{{ formatDateToMonthString(fieldSecond.input)}}</h5>
                                  <h5 v-else class="mb-0 text-uppercase">{{ (fieldSecond.input != '' && fieldSecond.input == '0') ? 'No' :
                                    (fieldSecond.input != '' && fieldSecond.input == '1') ? 'Yes' :
                                    capitalizeFirstLetter(fieldSecond.input,fieldSecond.label) }}</h5>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-if="details.fields">
                        <div :class="{'fieldgrp row': details.name!='nomineeInfo', 'fieldgrp col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6': details.name=='nomineeInfo' }"  v-for="fieldFirst in Object.values(details.fields)" :key="fieldFirst.id" v-show="fieldFirst!= undefined && fieldFirst.input != ''">
                          <div class="content mt-3" v-if="fieldFirst!= undefined && fieldFirst.input != ''">
                            <div class="d-flex flex-column mb-2" style="gap:8px">
                              <p class="diy_label mb-0">{{ fieldFirst.label }}</p>
                              <h5 class="mb-0 text-uppercase">{{ (fieldFirst.input != '' && fieldFirst.input == '0') ? 'No' :
                                (fieldFirst.input != '' && fieldFirst.input == '1') ? 'Yes' :
                                capitalizeFirstLetter(fieldFirst.input,fieldFirst.label) }}</h5>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </transition>
                </article>
              </template>
              
              <div class="col-md-12 mt-4 w-100">
                <button class="btn commonButton mb-2" @click="submitproposal()" :disabled="selectedPlan && selectedPlan.supportingData && selectedPlan.supportingData?.userConsent && selectedPlan.supportingData?.userConsent[0]?.condition ? !condition : false">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <VarificationModal />
  <AmountBreakupSq v-if="this.openAmountBreakupflag" @emitClose="emitClose()"/>
  <pageLoader v-if="loadingState" :msg="loadingMessage"/>
  <Verifypremium v-if="Verifypremiumflag" @emitVerifyClose="VerifymodalClose" @emitcontinueNewPremium="continueNewPremium"/>
</template>

<script>
import VarificationModal from "@/modals/varificationModal.vue";
import InnerHeader from "../header/innerHeader.vue";
import pageLoader from "../pageLoaders/pageLoader.vue";
import AmountBreakupSq from "@/modals/amountBreakupSq.vue";
import ProductDetailsHeader from "../productDetailsHeader/ProductDetailsHeader.vue";
import { getDistributer} from '@/mixins/common';
import Verifypremium from "@/modals/verifypremium.vue";
import ConsentDaata from "./ConsentDaata.vue";
export default {
  mixins: [getDistributer],
  components: {
    VarificationModal,
    InnerHeader ,
    pageLoader,
    AmountBreakupSq,
    ProductDetailsHeader,
    Verifypremium,
    ConsentDaata,
  },
  methods: {
    fullNameExists() {
      return !!this.proposalDetails?.proposal_json?.fieldGroups?.proposerDetails?.fieldGroups?.personalDetails?.fields 
            && !!this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.fullName?.input?.trim();
    },
    isNameField(label) {
      return ['First Name', 'Middle Name', 'Last Name'].includes(label);
    },
    VerifymodalClose(){
     this.Verifypremiumflag=false;

    },
    continueNewPremium(){
      this.Verifypremiumflag=false;
      this.updateProposalStatus(11);
    },
    compareValues(dataArray, dataObject) {
      console.log("array",dataArray,dataObject)
    for (const item of dataArray) {
      const proposalValue = this.getValueFromPath(dataObject, item.proposalPath);
      const singleQuoteValue = this.getValueFromPath(dataObject, item.singleQuotePath);

      if (proposalValue !== singleQuoteValue) {
        console.log("proposalValue ", proposalValue, singleQuoteValue);
        this.Sqflag = true;
        break;
      }
    }
    console.log("sqflag",this.Sqflag)
  },
   getValueFromPath(object, path) {
    return path.split('.').reduce((acc, key) => acc && acc[key], object);
},
    getCkycDetails() {
      this.loadingState = true;
      this.loadingMsg="Fetching CKYC Details"
      var self = this;
      // this.loading = true;
      this.kycRedirectUrl = "";
      this.msg = [];

      let reqData = {
        "personalInformation": {
          "dateOfBirth": this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input,
          "email": "",
          "mobileNumber":this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.mobileNumber.input ,
          "zipCode": this.proposalDetails.proposal_json.fieldGroups.proposerDetails.fieldGroups.permanentAddressDetails.fields.zipCode.input,
          "pan": this.PANNumber,
          //Gender For Testing
          "gender":"male"
        },
        "product": {
          "insuranceCompanyCode": this.selectedPlan.insuranceAndProducts.insuranceCompanyCode,
          "productId": this.selectedPlan.insuranceAndProducts.productCode,
        },
        "trackInfo": {
          "manufacturerQuoteID": this.uniqueQuoteId.toString(),
          "manuApplicationNo":"" ,
          "KYCRequestID": ""
        },
        "distributor": {
          "distributorID":this.distributorID,
          "agentID": this.getAgentIdFromRmData(this.rmData),
          "salesChannel": "online",
          "channelType": this.rmData.RoleId !== "1" ? "B2B" : "B2C",
        },
        "kycInfo": {
          "ReturnURL": "https://www.1silvebullet.tech"  
        },
        "journey_id": this.journey_id,
      };

      // Save request json  
      //sessionStorage.setItem("request_json", JSON.stringify(reqData));
      let headers = {"Authorization":`Bearer ${ this.$store.state.token}`};
      console.log('calling kyc...')
      this.backendApi("getCkyc", reqData, headers)
        .then((response) => {
          this.loadingState=false;
          
          this.kycResponse = response?.data?.data;
          this.kycStatus = this.kycResponse?.kycInfo?.Status;

          if(response.data.errors.length > 0) {
            for(let i=0; i<response.data.errors.length; i++)
            {
              this.msg.push('Verify that your PAN-Date of Birth combination is correct and try again. If the issue continues, please contact the support staff.');
            } 
          } else if(this.kycStatus == "approved") {
            this.loadingState = false;
            if(this.newsqData.productDetails.totalPremiumDetails[0].totalPremiumWithTax!==this.quoteResponseDetails.quote_response_data.productDetails.totalPremiumDetails[0].totalPremiumWithTax){
              this.Verifypremiumflag=true;
            }
            else{
              this.updateProposalStatus(11);
            }
            // this.$router.push({ path: '/process-wizard' })
            sessionStorage.setItem("kyc_response", JSON.stringify(this.kycResponse));
            // let userData = JSON.parse(sessionStorage.getItem("userData")); 
            // setTimeout(function() { 
            //   self.$router.push("/process-wizard");
            // }, 2000);            
          } else if(response.data.data.kycInfo.Status == null && response.data.data.kycInfo.RedirectURL == null) {
            
            // this.getCkycDetails2();

          } else if((this.kycStatus == "Pending" || this.kycStatus == "POAIncomplete" || this.kycStatus == "Incomplete")) {
            this.isUploadDocRequired = true;
          } else  {
            sessionStorage.removeItem('kyc_response');
            this.kycRedirectUrl = this.kycResponse.kycInfo.RedirectURL;
            setTimeout(function() { 
              window.open(self.kycRedirectUrl, '_blank').focus();
            }, 2000);
          }

        })
        .catch((error) => {
          console.log('error msg block : get kyc', error);
          self.loading = false;
        }); 
    },
    getSingleQuote() {
      // var self = this;
      // self.loading2 = true;
      this.loadingState = true;
      this.loadingMessage = "Submitting Proposal to insurer… Please wait"
      console.log("this.requestBody", this.apiReqData)
      this.apiReqData.product.ncbDetails.claimLastYearFlag = this.apiReqData.personalInformation.individualDetails[0].isOwnerTransfer  ? true : false;
      this.apiReqData.product.ncbDetails.numberOfClaims = this.apiReqData.personalInformation.individualDetails[0].isOwnerTransfer ? 1 : 0;
      
      sessionStorage.setItem("quote_request", JSON.stringify(this.apiReqData));
      this.backendApi("quotationApi", this.apiReqData, { "Authorization": `Bearer ${this.$store.state.token}` }, "post")
        .then((response) => {
          console.log("inside response sq")
          if (response.data.errors.length > 0) {
            // this.loading = false;
            this.displayApiErrorsOnUI = []
            this.loadingState = false;
      
            const msg = [];
            for (let i = 0; i < response.data.errors.length; i++) {
              msg.push(response.data.errors[i]["errorDisplayMessage"])
            }
            console.log("Errors in Response", msg);
            this.displayApiErrorsOnUI = msg;
            // this.$router.push({ path: '/error-page', query: { backUrl: 'policy-quote', msg: msg } });
          } else if (response && response.data) {
            
            this.requestId = response.data.reqId;
            // this.loading = false;
            if (response?.data?.data?.quote?.length > 0) {
              console.log("inside loop for")
              this.responseData.push(response.data.data.quote)
            }
            if (response.data.errors.length == 0) {
              const self = this;
setTimeout(function () {
  self.pollapiflag = true;
  self.pollData();
}, 1000);

            }
            else {
              console.log("inside else case")
              this.loadingState = false;
              // this.loading2 = false;
              if (this.responseData.length == 0) {
                this.erMsg = 'No products found as per your selected filter. Please change the filters.';
                // self.beforeDestroy();
              }
            }
          }

        }).catch((error) => {
          console.log('error msg block dp', error);
          const msg = "Service is Unavailable, Please try again later.";
          this.displayApiErrorsOnUI.push(msg);
          // this.$router.push({ path: '/error-page', query: { backUrl: 'policy-quote', msg: msg } });
        })
    },
    async getMotorProduct() {
      // this.loading2 = true;
      this.loadingState = true;
      const startTime = Date.now();
      const maxPollingTime = 3 * 60 * 1000;
      let headers = { "Authorization": `Bearer ${this.$store.state.token}` };
      let reqData = [this.requestId];

      while (this.pollapiflag && (Date.now() - startTime) < maxPollingTime) {
        try {
          // if(this.$route.path !== "/policy-details"){
          //   this.pollapiflag = false;
          //   break;
          // }
          const response = await this.backendApi("quotationPoll", reqData, headers, "get");
          if (response.data.errors.length > 0) {
            this.loading = false;
            this.loadingState = false;
            const msg = [];
            for (let i = 0; i < response.data.errors.length; i++) {
              msg.push(response.data.errors[i]["errorDisplayMessage"])
            }
            this.displayApiErrorsOnUI = msg;
            // this.$router.push({ path: '/error-page', query: { backUrl: 'policy-quote', msg: msg } });
          }
          if (response?.data?.data?.quote?.length > 0) {
            // this.loading2 = false;
            this.loadingState = false;
            this.suggestedIDV = response?.data?.data?.quote[0].supportingData.insuredDeclaredValue.suggestedIDV;
            this.responseData = response.data.data.quote;
            sessionStorage.setItem("quoteSingleData", JSON.stringify(this.responseData))
          }
          if (response.data.data.isPollComplete == true) {
            this.loadingState = false;
            this.pollapiflag = false;
            this.uniqueQuoteId=response.data.data.quote[0].trackInfo.manufacturerQuoteID;
            this.newsqData=response.data.data.quote[0];
            sessionStorage.setItem("updated_premium",JSON.stringify(this.newsqData));
            const isUploadDocRequired = sessionStorage.getItem("isUploadDocRequired") ? JSON.parse(sessionStorage.getItem("isUploadDocRequired")) : "";
            if(!isUploadDocRequired){
              this.getCkycDetails();
            } else {
              this.updateProposalStatus(11);
            }
            this.loading2 = false;
            // this.beforeDestroy();
            break;
          }
          if (response.data.errors.length > 0) {
            if (response.data.errors[0].errorIdentifier == "INVALID_REQUEST_ID") {
              this.pollapiflag = true;
            }
          }
          await this.sleep(1000);
        }catch(err){
          console.log('error msg block', err);
          this.loading = false;
        }
      };
      if ((Date.now() - startTime) >= maxPollingTime) {
        this.pollapiflag = false;
        this.loading2 = false;
        this.loading = false;
      }
    },
    pollData() {
      console.log("polling")
        if (this.pollapiflag == true) {
          this.getMotorProduct();
        } else {
          // this.loading2 = false;
          if (this.responseData?.length == 0) {
            this.erMsg = 'No products found as per your selected filter. Please change the filters.';
          }
          // this.beforeDestroy();
        }
    },
    editProcess(e, name){
      e.stopPropagation(); 
      sessionStorage.setItem(
        "currentTab",
        JSON.stringify(name)
      );
      this.$router.push({ path: '/process-wizard',  query: { process: name }})
    },
    showBreakupmodal(){
      console.log("clicked-------");
      this.openAmountBreakupflag=true;
    },
    extractUSP(obj) {
      const uspArray = [];
      for (let key in obj) {
        if (key.startsWith('usp') && obj[key] && obj[key] !== null && obj[key] !== undefined) {
          uspArray.push(obj[key]);
        }
      }
      return uspArray;
    },
    capitalizeFirstLetter(input,input2) {
  
      if(input2=="Date of Birth" || input2=="Policy Expiry Date" || input2=="Previous Policy Expiry Date"){
        const date = new Date(input);
      if (isNaN(date.getTime())) return input; // Return original if invalid date

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return this.formatDateToMonthString(`${month}-${day}-${year}`);
       }
       if(input2=="Gender" || input2=="Marital Status" || input2=="Type of Finance" || input2=='Automobile Association' || input2=='Occupation'){
        return input.toUpperCase();
       }
      if (typeof input !== 'string' || input === '') return input;
      return input.charAt(0).toUpperCase() + input.slice(1);
     
    },
    currency(amt) {
      const tmpAmt = parseFloat(amt).toFixed(2);
      return tmpAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    submitproposal(){
      // if(this.Sqflag){
        // this.getSingleQuote()
      // }
      // else{
      this.updateProposalStatus(11);   
      // }
        
    },
    async updateProposalStatus(statusid) {
      try {
        if (!statusid) {
          console.warn("Invalid status ID provided.");
          return;
        }

        let qData = {
          journey_id: this.journey_id,
          status_id: statusid,
        };

        let headers = {
          Authorization: "Basic " + window.btoa(process.env.VUE_APP_USERNPASS),
          "Content-Type": "application/json",
        };

        this.loadingState = true;
        this.loadingMessage = "Updating Proposal Status";

        const response = await this.backendApi("ProposalStatus", qData, headers);

        if (!response || response === "error") {
          console.error("API returned an error response.");
          this.apiError = true;
          return;
        }

        if (response?.data) {
          if ([11, 13].includes(statusid)) {
            if (response.data.status === "failed") {
              let msg = ["We are facing some issues while sending an e-mail"];
              this.$router.push({ path: "/networkalert", query: { backUrl: "proposal-details-check", msg: msg } });
            } else {
              this.$router.push({ name: 'completeThankyou' });
            }
          }
        }
      } catch (error) {
        console.error("Error updating proposal status:", error);
        this.loadingState = false;
      }
    },
    emitClose(){
      this.openAmountBreakupflag = false;
    },
    getSPDetailsOneSB(man_code ) {
      let reqData = [man_code];
      var headers ={ "Authorization": `Bearer ${this.$store.state.token}` };
      this.loadingState = true;
      this.loadingMessage = "Fetching SP Details"
      this.backendApi("getSPDetailsOneSB", reqData, headers, "get")
      .then((response) => {
        this.loadingState = false;
        if(response == 'error') {
          self.apiError = true;
        } else if(response && response.data) {
          console.log('response sp details: ', response.data);
          if(response.data.status == "failed")
          {
            //redirection to error page and on go back button redirect to homepage
          }
          sessionStorage.setItem("sp_details_data", JSON.stringify(response.data));
        }
      })
      .catch((error) => {
        this.loadingState = false;
        console.log('error msg block spdetailOneSB API', error);
        this.displayApiErrorsOnUI.push(msg);
        // this.$router.push({ path: '/error-page', query: {msg: "SP details not Available" }});

      });
    },
    //get ProposalDetails
    getProposalById(journey_id) {
      let qData = [this.journey_id,"Proposal Review", "false"];
      var headers ={ "Authorization": `Bearer ${this.$store.state.token}` };
      this.loadingState = true;
      this.loadingMessage = "Fetching Proposal Details..."
      this.backendApi("getProposalDetails", qData, headers, "get")
      .then((response) => {
          this.loadingState = false;
          this.proposalDetails = response.data.data.proposal;
          // console.log("",this.SQ_CALL_BEFORE_PROPOSAL);
          // const insuranceCompanyCode=response.data.data.quote_response.quote_response_data.insuranceAndProducts.insuranceCompanyCode;
          // console.log("productcode",insuranceCompanyCode)
          // var rsgiArray;
          // if(this.SQ_CALL_BEFORE_PROPOSAL){
            // rsgiArray= this.SQ_CALL_BEFORE_PROPOSAL[insuranceCompanyCode];
          // }
          
          if(this.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING){
            this.compareValues(this.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING,response.data)
          }
          if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input){
        this.apiReqData.personalInformation.individualDetails[0].firstName=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.firstName.input){
        this.apiReqData.personalInformation.individualDetails[0].middleName=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.middleName.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input){
        this.apiReqData.personalInformation.individualDetails[0].lastName=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.lastName.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.gender.input){
        this.apiReqData.personalInformation.individualDetails[0].gender=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.gender.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input){
        this.apiReqData.personalInformation.individualDetails[0].dateOfBirth=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.dateOfBirth.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input){
        this.apiReqData.personalInformation.individualDetails[0].email=response.data.data.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields.email.input
      }
      // 
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyEndDate=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyInsurer=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyNumber=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyOdExpiryDate=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
      }

      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyInsurer=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
      }

      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyOdNumber=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input){
        // this.apiReqData.product.previousPolicyDetails.previousPolicyTpExpiryDate=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyEndDate.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyTpInsurer=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyInsurer.input
      }
      if(response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input){
        this.apiReqData.product.previousPolicyDetails.previousPolicyTpNumber=response.data.data.proposal.proposal_json.fieldGroups.previousPolicyDetails.fieldGroups.ownDamagePolicyDetails.fields.previousPolicyNumber.input
      }
      
      
        
          sessionStorage.setItem(
            "filledData",
            JSON.stringify(this.proposalDetails.proposal_json)
          );
          sessionStorage.setItem(
            "proposal_ui_id",
            JSON.stringify(this.proposalDetails.proposal_ui_id)
          );
          //call sp details api 
          let spdetail_flag= process.env.VUE_APP_SPDETAIL_ONESB;
          this.restructureJson();
          if(spdetail_flag == 1)
          {
            if (sessionStorage.getItem("rm_data")){
              this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
              if( this.rmData['RoleId']!=="1"){
                this.getSPDetailsOneSB( this.proposalDetails.insurance_company_code);
              }
            }
          }
          this.quoteDetails = response.data.data.quote_request;
          this.userDetails = response.data.data.user;

          let userData=JSON.parse(sessionStorage.getItem("userData"))
          if(!userData){
            this.PANNumber=this.userDetails.PANNumber;
          }else{
            this.PANNumber=userData.PANNumber;
          }
          
          
          sessionStorage.setItem(
            "user_profile",
            JSON.stringify(this.userDetails)
          );
          sessionStorage.setItem(
            "quote_request",
            JSON.stringify(this.quoteDetails.quote_request_json)
          );
          
          this.quoteResponseDetails = response.data.data.quote_response;
          
          let pln = this.quoteResponseDetails.quote_response_data;
          sessionStorage.setItem("selected_plan_data", JSON.stringify(pln));
          this.addontoShow=pln.productDetails.motorCovers;
          sessionStorage.setItem(
            "selectedPlanForCheckout",
            JSON.stringify(pln)
          );
          sessionStorage.setItem(
            "journey_id",
            JSON.stringify(journey_id)
          );
          this.$store.commit("setJourneyId", journey_id);
          if (this.proposalDetails.tag_name) {
            sessionStorage.setItem(
              "filledDataTab",
              JSON.stringify(this.proposalDetails.tag_name)
            );
            sessionStorage.setItem(
              "currentTab",
              JSON.stringify(this.proposalDetails.tag_name)
            );
          }
        }) 
        .catch((error) => {
          this.loadingState = false;
          console.log("error msg block dp", error);
        });
    },
    restructureJson(){
        let addOnsObject = {
          expanded: false,
          data: this.quoteResponseDetails?.quote_response_data.productDetails.motorCovers,
          addOnSelected: []
        }
        this.structuredJSON.addOns = addOnsObject;
        const otherValues = Object.values(this.proposalDetails.proposal_json.fieldGroups)
  .filter(requiredFields => requiredFields.fieldGroups !== undefined)
  .filter(fields => fields.name != 'distributor')
  .map((item,index) => {
      return {
        ...item,
        expanded: index==0 ? true : false
      };
    });
    this.structuredJSON.otherRequiredFields = otherValues;

    // document.querySelectorAll('.form-check-input').forEach(element => element.setAttribute('checked', true));
    },
    formatDateToMonthString(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
        .replace(/ /g, '-');
    },
    displaySubHeading(data){
      let displayFlag = false;
      if (data.fields) {
          for (let key in data.fields) {
            if (data.fields[key].input && data.fields[key].input !== "") {
              displayFlag = true;
            }
          }
        }
        if (data.fieldGroups) {
          for (let key in data.fieldGroups) {
            if (data.fieldGroups[key].input && data.fieldGroups[key].input.trim() !== "") {
              displayFlag = true;
            }
          }
        }
        return displayFlag;
    }
  },
  mounted() {
    this.distributorID = getDistributer()["distributerID"];
    // this.selected_plan_data = JSON.parse(sessionStorage.getItem("selected_plan_data"));
    // this.SQ_CALL_BEFORE_PROPOSAL=this.$store.state.configData.SQ_CALL_BEFORE_PROPOSAL;
    this.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING=this.$store.state.configData.PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING
    this.apiReqData = JSON.parse(sessionStorage.getItem("quote_request"));
    // // this.setupData();
    this.selectedPlan=JSON.parse(sessionStorage.getItem("selected_plan_data"));
    this.journey_id = JSON.parse(sessionStorage.getItem("journey_id"));
    this.addontoShow=this.selectedPlan.productDetails.motorCovers;
    this.loadingState = true;
    this.getProposalById(this.journey_id);
    console.log("this.journey_id",this.journey_id);
    this.quoteCategory = this.$store.state.quoteCategory;
    if (sessionStorage.getItem("rm_data")) {
      this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
    }
  },
  data() {
    return {
      SQ_CALL_BEFORE_PROPOSAL:'',
      Sqflag:false,
      Verifypremiumflag:false,
      newsqData:'',
      distributorID:'',
      uniqueQuoteId:"",
      selectedPlan:'',
      pollapiflag:false,
      loadingState: false,
      loadingMessage: "",
      structuredJSON:{},
      userDetails:{},
      quoteDetails:{},
      proposalDetails:{},
      journey_id:"",
      responseData: [],
      addontoShow:[],
      openAmountBreakupflag:false,
      quoteResponseDetails:null,
      PANNumber:'',
      PROPOSAL_TO_SINGLEQUOTE_FIELD_MAPPING:'',
      displayApiErrorsOnUI: [],
      quoteCategory: "",
      items: [
        {
          rmData: null,
          selected_plan_data: null,
          quote_request: null,
          heading: "Plan Summary",
          BankLogo: "$SBI",
          planType: "Policy Type",
          plan: "₹ 14,560",
          coverType: "IDV Cover",
          cover: "₹13,36,452",
          nestedItems: [
            {
              checkitems: "Zero Paper Claims",
            },
            {
              checkitems: "Spot Claims Upto Rs. 20k",
              carcover: "₹ 14,560",
            },
            {
              checkitems: "28 Cashless Garages",
            },
            {
              checkitems: "Self-Video Claims",
            },
          ],
          premiumAmount: "Premium Amount",
          amount: "₹ 14,560",
          GSTType: "GST @18%",
          GST: "₹ 2620",
          amountTitle: "Total Amount",
          totalAmount: "₹ 17,180",
        },
      ],
      Addon: [
        {
          checkheadings: "Zero Paper Claims",
        },
        {
          checkheadings: "Spot Claims Upto Rs. 20k",
        },
        {
          checkheadings: "28 Cashless Garages",
        },
        {
          checkheadings: "Self-Video Claims",
        },
      ],
      Additions: [
        {
          id: 1,
          accoheading: "Owner Details",

          expanded: true,
          nestedItems: [
            {

              checkContent: "Akash Chopra",
              subcheck: "Name",
            },
            {
              
              checkContent: "+91 8888 38888",
              subcheck: "Mobile",
            },
            {
              
              checkContent: "16/04/1986",
              subcheck: "Date of Birth",
            },
            {
              
              checkContent: "AUK37878K",
              subcheck: "PAN",
            },
            {
              
              checkContent: "Male",
              subcheck: "Gender",
            },
            {
              
              addressContent: "328/330, Mangaldas Market, opposite Jumma Masjid, Mumbai, Maharashtra 400002, India",
              address: "Address",
            },
           
          ],
        },
        {
            id: 2,
          accoheading: "Vehicle Details",

          expanded: true,
          nestedItems: [
            {
              
              checkContent: "1887787377",
              subcheck: "Engine Number",
            },
            {
              
              checkContent: "299898798788",
              subcheck: "Chassis Number",
            },
            {
              
              checkContent: "Yes",
              subcheck: "Is your vehicle taken on loan?",
            },
            {
              
              checkContent: "SBI Auto Loan",
              subcheck: "Financier",
            },
           
           
          ],
        },
        {
            id: 3,
          accoheading: "Previous Policy Details",

          expanded: true,
          nestedItems: [
            
            {
                subcontent:"Own Damage Detail",
              checkContent: "SBI",
              subcheck: "Insurer",
            },
            {
              
              checkContent: "12/06/2025",
              subcheck: "Policy Expiry Date",
            },
            {
              
              checkContent: "99389898",
              subcheck: "Policy Number",
            },
        
          
           
          ],
        },
        
      ],
      condition: false,
      checkedConditions: [],
    };
  },
  computed: {
    resolveImagePath() {
      return (variable) => {
        // Map the SCSS variable name to its actual value
        const variableMap = {
          $SBI: "/images/state-bank-of-india-logo.svg", // Match this to your SCSS variable definition
        };
        return variableMap[variable] || "";
      };
    },
    filteredStructureJson(){
      const checkInputValues = (obj) => {
        if (obj.fields) {
          for (let key in obj.fields) {
            if (obj.fields[key].input && obj.fields[key].input.trim() !== "") {
              return true;
            }
          }
        }
        if (obj.fieldGroups) {
          for (let key in obj.fieldGroups) {
            if (checkInputValues(obj.fieldGroups[key])) {
              return true;
            }
          }
        }
        return false;
      };
      return this.structuredJSON.otherRequiredFields && this.structuredJSON.otherRequiredFields.filter(container => checkInputValues(container));
    } 
  },
 
 
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/components/select-card.scss";
@import "../../assets/scss/components/multi-quotes.scss";
@import "../../assets/scss/components/form-wizard.scss";

.errorMessage {
  color: rgb(255, 94, 94);
  font-size: 14px;
}
.fade-enter-active,
.fade-leave-active{
  transition: all 0.2s cubic-bezier(0.215, 0.610, 0.355, 1);
}
.fade-enter-from, .fade-leave-to{
  opacity: 0;
}
.fade-enter-to, .fade-leave-from {
  opacity: 1;
}
.mandatory-mark{
  color: $alert !important;
}

.confirm-checkbox{
  input[type="checkbox"]{
    transform: scale(1.4) translateY(4px);
  }
}
.confirmmark{
  font-size: 12px;
  margin-left: 10px;
  text-align: left;
  cursor: pointer;
  line-height: 18px;
  opacity: 0.8;
  &:hover{
    opacity: 1;
  }
}

.condition-container{
  display: grid;
  grid-template-columns: 20px 1fr;
  input, label{
    display: inline-block;
  }
  label{
    transform: translateY(-4px);
  }
  input[type="checkbox"]{
    width: 18px;
    height: 18px;
  }
} 
.editButton{
  width: 12px !important;
  height: auto;
}
.descliminar{
  font-size: 12px;
  margin-left: 10px;
  text-align: left;
  cursor: pointer;
  line-height: 18px;
  opacity: 0.8;
  &:hover{
    opacity: 1;
  }
}
.grid-view{
  // display: grid;
  // grid-template-columns: repeat ( 2, 1fr);
}
.dark{
  .editButton{
    filter: invert(1);
  }
  .condition-container{
    color: $commonColor !important;
    .descliminar{
      div{
        color: $commonColor !important;
      }
    }
  }
}

.editButton{
  width: 18px !important;
  height: auto;
}

.dark .descliminar{
  color:$commonColor !important;
  font-size: 12px;
}

/* New styles for improved aesthetics */
.review-panel {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.dark .review-panel {
  background-color: $cardBackgroundDark;
}

.FilterAccordian {
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s ease;
  header{
    cursor: pointer;
  }
}
.dark .FilterAccordian {
  background-color: $header-dark-bg !important;
}

.question-title {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.headingcards {
  border: 1px solid #eaeaea;
}

.dark .headingcards {
  border: 1px solid #3a3a3a;
}

.text-uppercase {
  font-weight: 600 !important;
  letter-spacing: 0.5px;
}

.processheading {
  position: relative;
  margin-top: 12px;
}

.commonButton {
  border-radius: 4px;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.commonButton:hover {
  transform: translateY(-2px);
}
.dark .confirmmark{
  color: $commonColor;
}
</style>
